import React, { useCallback, useEffect, useState } from 'react';

import { Divider } from '@material-ui/core';

import { basicRTEControls } from '../../config/allInteractives';
import { formatOptions } from '../../config/field-check';
import makePath from '../../utils/makePath';

import { ImageUpload, Select, RichTextEditor } from '../EditorFormElements';
import { FormFieldWrapper, SortableList } from '../Global';
import { Question } from '../PracticeComponents';
import { setItem } from '../../actions';
import { connect } from 'react-redux';

const unconnectedScenario = React.memo(({setItem, given = {}, ...props}) => {
  const path = makePath(props.path,props.index)

  const [format,setFormat] = useState('');

  const renderContentInput = () => {
    if (format === 'desk') {
      return <RichTextEditor 
              name="content"
              // label="Content"
              path={path}
              controls={basicRTEControls}
              given={given.content}
              defaultValue="Enter text to display for the scenario."
            />
    }
    else if (format === 'image') {
      return <ImageUpload
                name="image"
                label="Scenario Image"
                tooltip="Upload an image to display in this scenario. Recommended image size should have a max width of 1920px and a max height of 768px. File size should not exceed 250KB."
                includeAlt={true}
                altLabel="Image Alt Text"
                altPlaceholder="Provide image alt text that describes image to support screen readers."
                path={path}
                given={given.image}
              /> 
    } else {
      return <div></div>
    }

  }

  const callback = useCallback((name, value) => {
    setFormat(value)
  }, [setFormat])


  useEffect(() => {
    return () => {setItem(path, null)}
  }, [setItem,path])

  return (
    <>
      <FormFieldWrapper>
        <Select
          name="format"
          label="Scenario Format"
          options={formatOptions}
          callback={callback}
          path={path}
          given={given.format}
          help="If changed, you will lose content provided for other formats."
        />
      </FormFieldWrapper>

      <Divider />

      {format ? 
        <>
          <FormFieldWrapper>
              
            {renderContentInput()} 

          </FormFieldWrapper>

          <Divider />
        </>
      : '' }

      <SortableList
        name="questions"
        headerTag="h5"
        title={`Question ${props.index + 1}`}
        label="Question"
        path={path}
        given={given.questions}
        min={parseInt(props.numScenarios) === 1 ? 3 : 2}
        max={3}
      >
        <Question 
          defaultFormat='text'
        />
      </SortableList>
    </>
  )
})

export const Scenario = connect(null, {setItem})(unconnectedScenario)